import { InventoryCountTag } from './InventoryCountTag';
import { InventoryCountFilter } from './InventoryCountFilter';

export class InventoryCount {
    invCountId: number;
    code: string;
    catDetType: number;
    startDate: string;
    endDate: string;
    storeId: number;
    difference: number;
    costDifference: number;
    codeSAP?: string;
    codeServiceDesk?: string;
    insertedDate: string;
    lastDateUpdate: string;
    lastUserNameUpdate: string;
    catDetTypeName: string;
    storeName: string;
    inventoryCountTagQuantity: number;
    employeeName: string;
    inventoryCountTags: InventoryCountTag[];
    catDetJobName: string;
    inventoryCountFilters: InventoryCountFilter[];
    count: number;
    regionId: number;
    regionName: string;
    countSAP: number;
    hourSAP: string;
    countTPV: number;
    countValidation: number;
    language: number;
    storeTradeMark: string;
    organizationId: string;
    divisionNames: string;
}

